import { useElementSize } from '@/hooks/useElementSize';
import { DashboardPanel } from './DashboardPanel';
import { RailSkeleton } from './RailSkeleton';
import { RailStateBlock } from './RailStateBlock';
import { SessionPricePathChart } from './SessionPricePathChart';
import { formatSessionDateLabel } from './dashboardFormat';
import type { RailPanelState } from './railPanelState.utils';

interface SessionPricePathPanelProps {
  state: RailPanelState;
  ticker: string;
  sessionDate: string;
  onRetry: () => void;
}

export function SessionPricePathPanel({
  state,
  ticker,
  sessionDate,
  onRetry,
}: SessionPricePathPanelProps) {
  const [boxRef, boxSize] = useElementSize<HTMLDivElement>();
  const path = state.kind === 'ready' ? state.analytics.sessionPath : [];

  return (
    <DashboardPanel title="Session Price Path" subtitle={formatSessionDateLabel(sessionDate)}>
      {state.kind === 'loading' ? (
        <RailSkeleton className="mt-3.5 h-[180px]" />
      ) : state.kind === 'error' ? (
        <RailStateBlock
          tone="error"
          title="Price path unavailable"
          message={state.message}
          onRetry={onRetry}
        />
      ) : path.length < 2 ? (
        <RailStateBlock
          title="No completed session"
          message={`${ticker} has no regular-hours price path for ${formatSessionDateLabel(sessionDate)}. Pick another day.`}
        />
      ) : (
        <>
          <div ref={boxRef}>
            {boxSize.width > 0 && (
              <SessionPricePathChart
                path={path}
                currentPrice={state.analytics.currentPrice}
                width={boxSize.width}
              />
            )}
          </div>
          <div className="flex items-center gap-2 pl-7 text-xs text-fg">
            <i className="w-[18px] border-t-2 border-up" />
            {ticker} Price
          </div>
        </>
      )}
    </DashboardPanel>
  );
}
